import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { departmentsAPI } from '../../lib/api';

const Departments = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDepartments = async () => {
    setLoading(true);
    try {
      const response = await departmentsAPI.getAll();
      setDepartments(response.data);
    } catch (error) {
      console.error('Error fetching departments:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  const columns = [
    { key: 'name', label: 'Department Name' },
    { key: 'description', label: 'Description' },
  ];

  const formFields = [
    { name: 'name', label: 'Department Name', required: true, placeholder: 'Enter department name' },
    { name: 'description', label: 'Description', type: 'textarea', placeholder: 'Department description' },
  ];

  const handleAdd = async (data) => {
    await departmentsAPI.create(data);
    fetchDepartments();
  };

  const handleEdit = async (id, data) => {
    await departmentsAPI.update(id, data);
    fetchDepartments();
  };

  const handleDelete = async (id) => {
    await departmentsAPI.delete(id);
    fetchDepartments();
  };

  return (
    <DataTable
      title="Departments"
      description="Manage company departments"
      data={departments}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Departments;
